import {
  Checkbox,
  FormControlLabel,
  Grid2 as Grid,
  TextField
} from '@mui/material'
import { Formik, Form, FormikProps } from 'formik'
import React, { forwardRef, useImperativeHandle, useRef } from 'react'
import { Courier } from '../../../interfaces/Courier'
import { useApi } from '../../../hooks/useApi'
import { courierFormvalidationSchema, initialFormValues } from './config'
import { postCourier } from '../config/api'

export interface CourierFormNewRef {
  submit: () => void
}

interface CourierFormNewProps {
  onCreate: (success?: boolean) => void
  onSavingChange?: (loading: boolean) => void
  handleSnackbar: (msg: string | undefined, status: boolean) => void
}

export const CourierFormNew = forwardRef<
  CourierFormNewRef,
  CourierFormNewProps
>(({ onCreate, onSavingChange, handleSnackbar }, ref) => {
  const { callApi } = useApi()
  const formikRef = useRef<FormikProps<Courier>>(null)

  const requestCreateCourier = (courier: Courier) => {
    const { hasPriorization, ...rest } = courier
    onSavingChange?.(true)
    callApi(postCourier({ ...rest, HasPriority: hasPriorization } as unknown as Courier))
      .then(() => {
        handleSnackbar('Courier creado correctamente', true)
        onCreate(true)
      })
      .catch((error) => {
        handleSnackbar(error, false)
        onCreate()
      })
      .finally(() => onSavingChange?.(false))
  }

  useImperativeHandle(ref, () => ({
    submit: () => formikRef.current?.submitForm()
  }))

  return (
    <Formik
      innerRef={formikRef}
      initialValues={initialFormValues}
      validationSchema={courierFormvalidationSchema}
      onSubmit={requestCreateCourier}
    >
      {({ values, handleChange }) => (
        <Form>
          <Grid container spacing={0.5}>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                name='name'
                value={values.name}
                onChange={handleChange}
                label='Nombre de Courier'
                variant='outlined'
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <FormControlLabel
                sx={{ my: -0.5 }}
                control={
                  <Checkbox
                    name='active'
                    size='medium'
                    color='primary'
                    checked={values.active}
                    onChange={handleChange}
                  />
                }
                label='Activo'
              />
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
})

CourierFormNew.displayName = 'CourierFormNew'
